module.exports = __webpack_public_path__ + "amcharts/images/eraserIcon.gif";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/eraserIcon.gif
// module id = 262
// module chunks = 0